export const LeftArrow=()=>{
    return(
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.96 2.58376L12.177 1.80078L5.36847 8.60929L4.994 9.00078L5.36847 9.39227L12.177 16.2008L12.96 15.4178L6.54294 9.00078L12.96 2.58376Z" fill="#2C3E50"/>
      </svg>
    )
  }